import { useModals } from 'almanac-ui/Modal'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { Link, generatePath } from 'react-router-dom'
import { BRAND_KITS_PATH } from 'paths'
import { Brand } from 'blaze-ui/icons'

interface Props {
  workspaceId: number
}

export const GoToBrandsButton = ({ workspaceId }: Props) => {
  const { closeAllModals } = useModals()

  return (
    <ButtonLink
      frontIcon={Brand}
      variant="tertiary"
      size="md"
      elementType={Link}
      to={generatePath(BRAND_KITS_PATH, { workspaceId })}
      onPress={() => {
        closeAllModals()
      }}
    >
      Go To Brand AI
    </ButtonLink>
  )
}
